module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Wood_MockedUp.12380ee2.jpg";